import { useState } from 'react';

import { MilesTable } from 'components';

import { Issuance } from 'codegen';

import { IssuanceItemTable } from './IssuanceItemTable';
import { columns } from './lib';

export const IssuancesTable = ({
  snapId,
  dataSource,
  transactionId,
}: {
  snapId?: number;
  dataSource?: Issuance[];
  transactionId: number;
}) => {
  const [expandedId, setExpandedId] = useState<number>();

  return (
    <MilesTable
      size='small'
      rowKey='id'
      columns={columns}
      dataSource={dataSource}
      expandable={{
        onExpand: (isEpanded, { id }) => {
          if (isEpanded) {
            setExpandedId(id);
          }
        },
        expandedRowRender: ({ id }) => (
          <IssuanceItemTable
            snapId={snapId}
            issuanceId={id}
            expandedId={expandedId}
            transactionId={transactionId}
          />
        ),
      }}
    />
  );
};
